import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Loader2, CheckCircle, XCircle, ShieldAlert } from 'lucide-react';
import { toast } from 'sonner';

const Teste = () => {
  const { user, userProfile, loading } = useAuth();
  const [loadingAction, setLoadingAction] = useState(false);

  // BOTÃO 1: SIMULA APROVAÇÃO E ADICIONA 30 DIAS
  const handleActivate = async () => {
    if (!user) return toast.error("Nenhum usuário logado!");
    setLoadingAction(true);
    try {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 30); // Soma 30 dias na data atual

      await updateDoc(doc(db, 'users', user.uid), {
        paymentStatus: 'active',
        subscriptionExpiresAt: expirationDate.toISOString()
      });
      toast.success("Sucesso: Status 'active' e +30 dias injetados!");
    } catch (error) {
      console.error(error);
      toast.error("Erro ao atualizar o banco de dados.");
    } finally {
      setLoadingAction(false);
    }
  };

  // BOTÃO 2: REMOVE O ACESSO (BLOQUEIA)
  const handleDeactivate = async () => {
    if (!user) return toast.error("Nenhum usuário logado!");
    setLoadingAction(true);
    try {
      await updateDoc(doc(db, 'users', user.uid), {
        paymentStatus: 'pending',
        subscriptionExpiresAt: "" // Apaga a data de validade
      });
      toast.warning("Sucesso: Status definido como 'pending' e validade limpa!");
    } catch (error) {
      console.error(error);
      toast.error("Erro ao atualizar o banco de dados.");
    } finally {
      setLoadingAction(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-blue-600" size={32} />
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-100 p-6">
      <Card className="w-full max-w-md p-6 bg-white rounded-[2rem] shadow-xl border-none space-y-6 text-left">
        
        {/* CABEÇALHO DA PÁGINA */}
        <div className="flex items-center gap-2 border-b border-slate-100 pb-4">
          <ShieldAlert className="text-orange-500" size={24} />
          <div>
            <h2 className="text-xl font-black uppercase italic tracking-tighter text-slate-900">Painel do Desenvolvedor</h2>
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Página Isolada: Teste.jsx</p>
          </div>
        </div>

        {/* MONITOR DE DADOS DO BANCO */}
        <div className="bg-slate-50 p-4 rounded-2xl space-y-2 border border-slate-200/60">
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Dados Atuais do Técnico</p>
          <div className="flex justify-between text-xs font-semibold">
            <span className="text-slate-500">E-mail:</span>
            <span className="text-slate-800">{user?.email || 'Deslogado'}</span>
          </div>
          <div className="flex justify-between text-xs font-semibold items-center">
            <span className="text-slate-500">paymentStatus:</span>
            <Badge className={`border-none text-[10px] font-black uppercase tracking-wider ${userProfile?.paymentStatus === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
              {userProfile?.paymentStatus || 'null'}
            </Badge>
          </div>
          <div className="flex justify-between text-xs font-semibold">
            <span className="text-slate-500">Validade (ExpiresAt):</span>
            <span className="text-slate-800 font-mono text-[11px]">{userProfile?.subscriptionExpiresAt || 'Sem data ativa'}</span>
          </div>
        </div>

        {/* BOTÕES DE CONTROLE COMPARTILHADO */}
        <div className="flex flex-col gap-3 pt-2">
          <Button 
            onClick={handleActivate} 
            disabled={loadingAction}
            className="h-14 bg-green-600 hover:bg-green-700 text-white font-black uppercase italic text-xs tracking-wider rounded-xl shadow-md flex gap-2"
          >
            {loadingAction ? <Loader2 className="animate-spin" size={16} /> : <CheckCircle size={16} />}
            Liberar Técnico (+30 Dias)
          </Button>

          <Button 
            onClick={handleDeactivate} 
            disabled={loadingAction}
            className="h-14 bg-red-600 hover:bg-red-700 text-white font-black uppercase italic text-xs tracking-wider rounded-xl shadow-md flex gap-2"
          >
            {loadingAction ? <Loader2 className="animate-spin" size={16} /> : <XCircle size={16} />}
            Remover Acesso (Bloquear)
          </Button>
        </div>

      </Card>
    </div>
  );
};

export default Teste;